import QuestionnaireRating from './QuestionnaireRating'

export {
  QuestionnaireRating
}


// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireRating/index.js